import { InboxItemApplicationService } from '../../../inbox-management/application/services/InboxItemApplicationService';
import { createInboxTools } from '../../infrastructure/tools/inbox-ai-tools';

/**
 * GTD AI Tools Application Service
 * 
 * Simple application service that provides GTD AI tools
 * following the existing pattern from ai-domain
 */
export class GTDAIToolsApplicationService {
  
  constructor(
    private readonly inboxService: InboxItemApplicationService,
  ) {}

  /**
   * Get all available GTD AI tools
   * 
   * Returns tools compatible with Vercel AI SDK
   */
  getAITools() {
    const inboxTools = createInboxTools(this.inboxService);
    
    return {
      ...inboxTools,
    };
  }

  /**
   * Get AI tools metadata
   */
  getAIToolsMetadata() {
    const tools = this.getAITools();
    
    return {
      domain: 'GTD',
      boundedContext: 'ai-tools',
      version: '1.0.0',
      tools: Object.keys(tools),
      totalTools: Object.keys(tools).length,
      lastUpdated: new Date().toISOString()
    };
  }
}